import { pickBy } from 'lodash';
import { identity } from 'lodash/fp';
// Constants
const adjustDomains = ['link.swcapp.com', 'staging7.sweatco.in'];
const adjustHost = 'https://fgjq.adj.st';
const adjustLinkToken = '1osfh5nh';
// Utility functions
function generateAdjustLabel(params) {
    return Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
        .join('%26');
}
export function generateAdjustUrl(label, deeplink = '') {
    const path = deeplink ? `/${deeplink}` : '';
    return `${adjustHost}${path}?adj_t=${adjustLinkToken}&adj_label=${encodeURIComponent(label)}`;
}
// Core Adjust functions
export function generateAdjustInviteQuery(user, options) {
    // Extract all parameters from deeplink_path if it exists
    let deeplinkPath = options.deeplink_path || '';
    const pathParams = {};
    if (deeplinkPath) {
        const [path, queryString] = deeplinkPath.split('?');
        if (queryString) {
            const urlParams = new URLSearchParams(queryString);
            urlParams.forEach((value, key) => {
                pathParams[key] = value;
            });
        }
        // Remove the query parameters from deeplink_path
        deeplinkPath = path;
    }
    const params = pickBy(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ inviter_id: pathParams.inviter_id || (user === null || user === void 0 ? void 0 : user.id) || '', inviter_name: (user === null || user === void 0 ? void 0 : user.fullname) || '', channel: options.channel || 'other', feature: options.feature || 'invite', campaign: options.campaign }, (options.challenge_id
        ? {
            challenge_id: options.challenge_id,
            deeplink_path: `/walk-with-friends/${options.challenge_id}`,
            feature: 'challenge_invite',
        }
        : {})), (options.group_id
        ? {
            group_id: options.group_id,
            deeplink_path: `/group/${options.group_id}`,
            feature: 'group_invite',
        }
        : {})), (options.welcome
        ? {
            deeplink_path: '/onboarding-popup',
        }
        : {})), { deeplink_path: deeplinkPath }), pathParams), identity);
    const label = generateAdjustLabel(params);
    const deeplink = params.deeplink_path ? params.deeplink_path.replace(/^\//, '') : '';
    return generateAdjustUrl(label, deeplink);
}
export const generateAdjustLink = ({ inviterId, inviterName, channel = 'other', feature = 'invite', campaign, deeplink_path, }) => {
    const params = {
        inviter_id: inviterId,
        inviter_name: inviterName,
        channel,
        feature,
        campaign,
        deeplink_path,
    };
    const label = generateAdjustLabel(params);
    return generateAdjustUrl(label, deeplink_path);
};
export function isAdjustDomain(domain) {
    return adjustDomains.some((d) => domain.includes(d));
}
